// import React, { useEffect, useState } from "react";
// import { mapTableRows } from "../../../../../utils/mapTableRows";
// import {
//   Button,
//   DocumentsList,
//   Modal,
//   NewTable,
// } from "../../../../../components";

// //

// import { useSelector, useDispatch } from "react-redux";
// import {
//   getEmployeeByUiidStart,
//   setEmployeeProfileUiid,
// } from "../../../../../redux/slices/employee/employeeSlice";
// import { formatWords, getValueByKey, dateFormator } from "../../../../../utils";

// const I94 = () => {
//   const dispatch = useDispatch();

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedDocuments, setSelectedDocuments] = useState([]);

//   const employeeProfileUiid = useSelector(
//     (state) => state.employee.employeeProfileUiid
//   );
//   const { employeeDetails, loadedTabs } = useSelector(
//     (state) => state.employee.currentEmployee
//   );

//   const handelDocumetsModal = (documents) => {
//     setSelectedDocuments(documents);
//     setIsModalOpen(true);
//   };

//   useEffect(() => {
//     if (employeeProfileUiid && !loadedTabs.includes("i94Tab")) {
//       dispatch(
//         getEmployeeByUiidStart({
//           uiid: employeeProfileUiid,
//           tab: "i94Tab",
//           ret: "i94",
//         })
//       );
//     }
//   }, [employeeProfileUiid, loadedTabs, dispatch]);

//   const { i94 } = employeeDetails || {};
//   ///

//   const tableData = i94?.i94 || [];
//   const tableData2 = i94?.i140 || [];
//   const columns = [
//     { key: "number", label: "I-94 Number" },
//     {
//       key: "doe",
//       label: "Most Recent Date of Entry",
//       render: (row) => dateFormator(row.doe, "month-day-year"),
//     },
//     {
//       key: "admitDate",
//       label: "Admit Untill Date",
//       render: (row) => dateFormator(row.admitDate, "month-day-year"),
//     },
//     {
//       key: "exitDate",
//       label: "Actual Exit Date",
//       render: (row) => dateFormator(row.exitDate, "month-day-year"),
//     },
//     { key: "addmissionClass", label: "Class of Admission" },
//     {
//       key: "priorityDate",
//       label: "Priority Date",
//       render: (row) => dateFormator(row.priorityDate, "month-day-year"),
//     },
//     { key: "status", label: "Status" },

//     {
//       key: "documents",
//       label: "Documents",
//       render: (row) => {
//         return (
//           <div
//             className="flex items-center gap-1 flex-row cursor-pointer"
//             onClick={() => handelDocumetsModal(row.documents)}
//           >
//             <span className="text-linkblue">{row.documents.length} Docs </span>
//             <div>
//               <Button
//                 type="icon"
//                 icon="docs"
//                 size="xs"
//                 variant="text"
//                 color="black"
//               />
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       key: "",
//       label: "Action",
//       render: (row) => {
//         return (
//           <div>
//             <Button
//               type="icon"
//               size="sm"
//               color="dark"
//               variant="text"
//               icon="edit_square"
//             />
//           </div>
//         );
//       },
//     },
//   ];

//   const columns2 = [
//     { key: "petitionerSponser", label: "Petitioner Sponsored" },
//     {
//       key: "filingDate",
//       label: "Date I-140 Filed",
//       render: (row) => dateFormator(row.filingDate),
//     },
//     { key: "receiptNum", label: "Receipt Number" },
//     {
//       key: "isApproved",
//       label: "Is I-140 Approved",
//       render: (row) => (row.isApproved === true ? "True" : "False"),
//     },
//     { key: "comments", label: "Comments" },
//   ];

//   const mappedRows = mapTableRows(tableData, columns);
//   const mappedRows2 = mapTableRows(tableData2, columns2);
//   return (
//     <div className="mt-3 flex-1 ">
//       <NewTable rows={mappedRows} columns={columns} hideToolBar />
//       <NewTable rows={mappedRows2} columns={columns2} hideToolBar />
//       <Modal
//         width="max-w-2xl"
//         title={"Document Details"}
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//       >
//         <DocumentsList data={selectedDocuments} />
//         {/* <div className="flex flex-col gap-2">
//           {selectedDocuments.map((doc, index) => (
//             <div key={index} className="flex justify-between items-center">
//               <div className="flex items-center gap-3">
//                 <span className="material-symbols-rounded font-light text-3xl text-primary">
//                   description
//                 </span>
//                 <h6 className="line-clamp-1 font-normal">
//                   {doc} some more text with thsi text oth htat text
//                 </h6>
//               </div>
//               <div className="flex items-center gap-1">
//                 <Button
//                   type="icon"
//                   color="dark"
//                   variant="text"
//                   icon="download"
//                 />
//                 <Button type="icon" color="dark" variant="text" icon="delete" />
//               </div>
//             </div>
//           ))}
//         </div> */}
//       </Modal>
//     </div>
//   );
// };

// export default I94;

import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import {
  Button,
  DocumentsList,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";

//

import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeeByUiidStart,
  setEmployeeProfileUiid,
} from "../../../../../redux/slices/employee/employeeSlice";
import { formatWords, getValueByKey, dateFormator } from "../../../../../utils";
import { transformFiles } from "../../../../../utils/transformFiles";

const I94 = ({ handleEdit194 }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );

  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (employeeProfileUiid && !loadedTabs.includes("i94Tab")) {
      dispatch(
        getEmployeeByUiidStart({
          uiid: employeeProfileUiid,
          tab: "i94Tab",
            ret: "i94 i140",
                              ref: "i94Doc i140Doc",
        })
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  const { i94,i140 } = employeeDetails || {};

  const tableData = i94 || [];
  const tableData2 = i140 || [];
  const columns = [
    { key: "number", label: "I-94 Number" },
    {
      key: "doe",
      label: "Most Recent Date of Entry",
      render: (row) => dateFormator(row.doe, "month-day-year"),
    },
    {
      key: "admitDate",
      label: "Admit Untill Date",
      render: (row) => dateFormator(row.admitDate, "month-day-year"),
    },
    {
      key: "exitDate",
      label: "Actual Exit Date",
      render: (row) => dateFormator(row.exitDate, "month-day-year"),
    },
    { key: "addmissionClass", label: "Class of Admission" },
    {
      key: "priorityDate",
      label: "Priority Date",
      render: (row) => dateFormator(row.priorityDate, "month-day-year"),
    },
   {
  key: "status",
  label: "Status",
  render: (row) => {
    const statusMap = {
      1: "Active",
      2: "Filed Extension",
      3: "Inactive"
    };

    const statusText = statusMap[row?.status] || "Unknown";

    // return <div>{statusText}</div>;
    return <StatusTags tag={statusText} />
  }
},

    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        return (
          <div
            className="flex items-center gap-1 flex-row cursor-pointer"
            onClick={() =>
              handelDocumetsModal(transformFiles(row.documents || []))
            }
          >
            <span className="text-linkblue">
              {transformFiles(row.documents || []).length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
    },
    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div>
            <Button
              type="icon"
              size="sm"
              color="dark"
              variant="text"
              icon="edit_square"
              onClick={() => handleEdit194(row)}
            />
          </div>
        );
      },
    },
  ];

  const columns2 = [
    { key: "petitionerSponser", label: "Petitioner Sponsored" },
    {
      key: "filingDate",
      label: "Date I-140 Filed",
      render: (row) => dateFormator(row.filingDate),
    },
    { key: "receiptNum", label: "Receipt Number" },
    {
      key: "isApproved",
      label: "Is I-140 Approved",
      render: (row) => (row.isApproved === true ? "True" : "False"),
    },
    { key: "comments", label: "Comments" },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  const mappedRows2 = mapTableRows(tableData2, columns2);
  return (
    <div className="mt-3 flex-1 ">
      <TableAdv tableId={`employee_workauthorization_i94_1`} rows={mappedRows} columns={columns} hideToolBar />
      <TableAdv tableId={`employee_workauthorization_i94_2`} rows={mappedRows2} columns={columns2} hideToolBar />
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default I94;
